import { z } from "zod";

import { type FormValidationOutput } from "./base";

const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters in length.")
  .regex(new RegExp(".*\\d.*"), "Password need to have at least one number.")
  .regex(
    new RegExp(".*[`~<>?,./!@#$%^&*()\\-_+=\"'|{}\\[\\];:\\\\].*"),
    "Password needs to have at least one special character.",
  )
  .regex(
    new RegExp(".*[A-Z].*"),
    "Password needs to have at least one uppercase character.",
  )
  .regex(
    new RegExp(".*[a-z].*"),
    "Password needs to have at least one lowercase character.",
  );

export function isValidPassword(password: string): FormValidationOutput {
  try {
    passwordSchema.parse(password);
    return { isValid: true, message: "" };
  } catch (e) {
    if (e instanceof z.ZodError) {
      return {
        isValid: false,
        message: e.issues[0]?.message ?? "Invalid password.",
      };
    }
    return { isValid: false, message: "Invalid password." };
  }
}
